export default "assets/images/icons/linkedin-4dd0f9ef.svg";